var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewport",staticClass:"viewport",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{ref:"text",style:({ transform: ("translateX(" + _vm.targetX + "px)")})},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }